import script from "./AccountDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountDetail.vue?vue&type=script&setup=true&lang=ts"

import "./AccountDetail.vue?vue&type=style&index=0&id=1d6b740b&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d6b740b"]])

export default __exports__